import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/about/About.vue'),
  },
  {
    path: '/blog/:link/:height',
    name: 'blog',
    component: () => import(/* webpackChunkName: "about" */ '../views/blog/Blog.vue'),
  },
  {
    path: '/careers',
    name: 'careers',
    component: () => import(/* webpackChunkName: "about" */ '../views/careers/Careers.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/contact/Contact.vue'),
  },
  {
    path: '/term-of-service',
    name: 'termOfService',
    component: () => import(/* webpackChunkName: "about" */ '../views/legal/TermOfService.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "about" */ '../views/legal/PrivacyPolicy.vue'),
  },
  {
    path: '/purchase-completed',
    name: 'purchaseCompleted',
    component: () => import(/* webpackChunkName: "about" */ '../views/legal/ParchaseCompleted.vue'),
  },
  {
    path:'*',
    redirect:'/'
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

export default router;
